import * as React from "react";
import { Paper, InputBase, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function Search({ handleSearchDebounce, setPage }) {
  return (
    <Paper
      component="form"
      elevation={0}
      sx={{
        p: "15px 18px",
        display: "flex",
        alignItems: "center",
        width: "inherit",
        height: "50px",
        borderRadius: "10px",
        justifyContent: "space-between",
      }}
    >
      <InputBase
        fullWidth
        placeholder="Search"
        onChange={(e) => {
          setPage(1);
          handleSearchDebounce(e.target.value);
        }}
        sx={{
          "&::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#000000",
            opacity: 0.4,
          },
        }}
        inputProps={{
          style: {
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#000000",
            opacity: 0.4,
          },
        }}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon sx={{ color: "rgba(128, 128, 128, 0.7)" }} />
      </IconButton>
    </Paper>
  );
}
